import MuiLink from '@mui/material/Link';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useAccess } from '../../../auth/access';
import { canOpen } from '../dashboards.utils';

/** A link only when the user can open its target; otherwise the children as plain content. */
export default function MaybeLink({
  to,
  children,
  sx,
  underline = 'hover',
  ariaLabel,
}: {
  to: string | null | undefined;
  children: ReactNode;
  sx?: SxProps<Theme>;
  underline?: 'none' | 'hover' | 'always';
  ariaLabel?: string;
}) {
  const access = useAccess();
  if (!to || !canOpen(to, access)) return <>{children}</>;
  return (
    <MuiLink component={RouterLink} to={to} underline={underline} color='inherit' sx={sx} aria-label={ariaLabel}>
      {children}
    </MuiLink>
  );
}

/** Hook form of the same rule, for whole-card click targets. */
export function useCanOpen(): (to: string | null | undefined) => boolean {
  const access = useAccess();
  return (to) => canOpen(to, access);
}
